import config from "../config";
import {Property} from "../redux/residentPortalApi";

export const formatPropertyType = (propertyType: string): string => {
  const numbers = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  const pokugaraTwoTypes = ['garden', 'manor', 'villa'];

  let formattedType = propertyType.replace(/-/g, ' ');

  if (pokugaraTwoTypes.includes(formattedType.toLowerCase())) {
    formattedType += ' Townhouse';
  }

  formattedType = formattedType.replace(/\b\d\b/g, digit => numbers[+digit]);
  formattedType = formattedType.replace(/\b\w/g, letter => letter.toUpperCase());

  return formattedType;
}

export const developmentInfo = (
  development: string,
  phase?: string,
  type?: string
): { name: string; logo: string; banner: string } => {
  const cdn = config.CDN_URL;

  if (development === 'pokugara') {
    const bannerMap: Record<string, string> = {
      stand: 'pokugara-stand.jpg',
      townhouse: 'pokugara-townhouse.jpg',
      garden: 'pokugara-garden.jpg',
      manor: 'pokugara-manor.jpg',
      villa: 'pokugara-villa.jpg',
    };

    const bannerFile = type ? bannerMap[type.toLowerCase()] : undefined;

    return {
      name: 'Pokugara Residential Estate',
      logo: `${cdn}/PRE+-+Townhouses.png`,
      banner: bannerFile ? `${cdn}/banners/${bannerFile}` : `${cdn}/banners/pokugara-banner.jpg`
    };
  }

  if (development === 'pomona') {
    return {
      name: 'Pomona City',
      logo: `${cdn}/pomona-logo.png`,
      banner: `${cdn}/banners/pomona-banner.jpg`
    };
  }

  if (development === 'millennium') {
    const blockMap: Record<string, string> = {
      'block-1': 'mh-block-1.jpg',
      'block-2': 'mh-block-2.jpg',
      'block-3': 'mh-block-3.jpg',
      'block-4': 'mh-block-4.jpg'
    };

    const bannerFile = phase ? blockMap[phase] : undefined;

    return {
      name: 'Millennium Heights',
      logo: `${cdn}/millenium-heights.png`,
      banner: bannerFile ? `${cdn}/banners/${bannerFile}` : `${cdn}/banners/mh-block-4.jpg`
    };
  }

  return {
    name: '',
    logo: '',
    banner: ''
  };
};

export function formatPropertyDesc(property: Property) {
  let formattedType = '';

  if (property?.development === 'millennium') {
    // Format Millennium with "Block <number>"
    if (property?.phase?.startsWith('block-')) {
      const blockNumber = property?.phase.split('-')[1];
      formattedType = `Block ${blockNumber}`;
    }
  } else if (property?.development === 'pokugara') {
    // Format Pokugara with "PRET <Type>"
    if (property?.phase === 'pret-1' || property?.phase === 'pret-stands') {
     formattedType = 'PRET 1';
    } else if (property?.phase === 'pret-2') {
      formattedType = 'PRET 2';
    }

  } else if (property?.development === 'pomona') {
    // Format Pomona with "<phase>"
    formattedType = `${property?.phase} ${property?.unitNumber}`;
  }

  return formattedType;
}

export function formatPropertyNumber(property: Property) {
  let formatted = '';

  if (property?.development === 'millennium') {
    // Format Millennium with "Block <number> Unit <unitNumber>"
    if (property?.phase?.startsWith('block-')) {
      const blockNumber = property?.phase.split('-')[1];
      formatted = `Block ${blockNumber} Unit ${property?.unitNumber}`;
    }
  } else if (property?.development === 'pokugara') {
    // Format Pokugara with "PRET-<number> Type <unitNumber>"
    if (property?.phase === 'pret-1') {
      formatted = `PRET-1 ${property?.unitNumber}`;
    } else if (property?.phase === 'pret-2' && property?.type) {
      const formattedType = property?.type.charAt(0).toUpperCase() + property?.type.slice(1).toLowerCase();
      formatted = `PRET-2 ${formattedType} ${property?.unitNumber}`;
    } else if (property?.phase === 'pret-stands' && property?.type) {
      formatted = `PRET ${property?.unitNumber}`;
    }
  } else if (property?.development === 'pomona') {
    // Format Pomona with "<phase> <unitNumber>"
    formatted = `${property?.phase} ${property?.unitNumber}`;
  }

  return formatted;
}